import { weekdayIndex, weekdayLabels } from './dateStyle'

// Kept as a function rather than a constant: which day the week starts on is
// the account's, and a module-level array would be frozen at whatever the
// first page of the session rendered.
export const WEEKDAY_LABELS = weekdayLabels

// Rails date columns serialize as "YYYY-MM-DD" — parse as local midnight rather than
// `new Date(iso)`, which reads the string as UTC and can land on the wrong local day.
export function parseISODate(iso: string): Date {
  const [year, month, day] = iso.split('-').map(Number)
  return new Date(year, month - 1, day)
}

export function toISODate(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function isSameDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()
}

export function startOfMonth(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), 1)
}

export function endOfMonth(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0)
}

export function addMonths(date: Date, delta: number): Date {
  return new Date(date.getFullYear(), date.getMonth() + delta, 1)
}

export function addDays(date: Date, delta: number): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + delta)
}

export function formatMonthLabel(date: Date): string {
  return date.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' })
}

export function formatDayHeading(date: Date): string {
  return date.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' })
}

// Whole weeks covering every day of the month, including the leading and
// trailing days needed to fill out the first and last — no partial weeks. The
// week starts where the account says it does.
export function getMonthGrid(monthDate: Date): Date[][] {
  const firstOfMonth = startOfMonth(monthDate)
  const lastOfMonth = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0)

  const leadingOffset = weekdayIndex(firstOfMonth)
  const trailingOffset = (7 - weekdayIndex(lastOfMonth) - 1) % 7

  const gridStart = addDays(firstOfMonth, -leadingOffset)
  const gridEnd = addDays(lastOfMonth, trailingOffset)

  const weeks: Date[][] = []
  let cursor = gridStart
  while (cursor <= gridEnd) {
    const week: Date[] = []
    for (let i = 0; i < 7; i++) {
      week.push(cursor)
      cursor = addDays(cursor, 1)
    }
    weeks.push(week)
  }
  return weeks
}
